import {APIClient} from '../backend/ApiClient';

export const useGetUiCombinedTemplates = () => {
    const apiClient = APIClient();

    return (activeOnly: boolean) => {
        return apiClient.getUiCombinedTemplates(activeOnly);
    };
}